module.exports = __webpack_public_path__ + "static/media/CircleTick.5f6c63e3.svg";